<template>
<div class="chapter">
<div class="inner_page">
<h4 class="h4"><a id="page_21"></a><a id="sec4"></a>Mrs. Autumn and Her Two Daughters</h4>
<p class="poem">We live in an ocean<br/>of white waiting to fall.<br/>One of us is not like our mother and it’s me. It’s I.<br/>My eyes are mostly closed.</p>
<p class="poem">My mother knows<br/>how to make snow. We never see<br/>our feet. Our skirts end in the oncoming frost.<br/>My sister wears ermine. I have a narrow waist.</p>
<p class="poem">I no longer curl my hair. Why bother?<br/>I love my sister but hate my mother<br/>yet we’re all of a piece.<br/>Endless snipsnip. Ragged fragment.</p>
<p class="poem">We still live where you last left us—<br/>between the palace where you keep your winter<br/>and the summer garden of the ersatz emperor.<br/>Did I hear you say China? If I did you are right.</p>
<p class="poem">We live atop the continent<br/>that contains such poverty. Such pollution.<br/>Such eerie beauty. Always a mountain.<br/>Always a screen. White washes</p>
<p class="poem">over me. I do not act<br/>like my mother. I lean farther.<br/>What I make annihilates the mirror of China<br/>but not the mountain.</p>
<p class="poem">Not the man walking away.<br/>My mother says throw more snow but I can’t<br/>help thinking.<br/>There is more to being than erasure.</p>
<p class="poem">You are wrong, she says. You don’t wear your cape.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter1_a.vue?2e9f72c0